export default __webpack_public_path__ + "static/media/logo_inverted.ff1fd695.png";